import React from "react";
import { useSelector } from "react-redux";
import Widget from "../../../features/widget/Widget";
import iconsList from "../../../ui/icons/iconsList";
import pathRouts from "../../../../enums/pathRoute";
import managementIllustration from "../../../../../assests/management/managementIllustration.png";
import classes from "./ManagementWidget.module.css";

const ManagementWidget = () => {

    const { texts } = useSelector(state => state.translate);

    return (
        <Widget
            color="#f6f6f6"
            width={250}
            height={250}
            title={texts.virtualSchoolManagement}
            icon={iconsList.managerDashboard}
            mainLink={`/${pathRouts.MANAGERDASHBOARD}/${pathRouts.LOGOANDIMAGE}`}
            className={classes.ManagementWidget}
        >
            <div className={classes.Content}>
                <img
                    src={managementIllustration}
                    className={classes.Illustration}
                    alt=""
                />
                <p className={classes.Description}>{texts.virtualSchoolManagementDesc}</p>
            </div>
        </Widget>
    );
};

export default ManagementWidget;
